import React, { useEffect, useState } from 'react';
import { Colors, Flex, IconShare, Typography } from '@banhala/ui-kit';
import Animated, {
  Easing,
  useAnimatedStyle,
  useSharedValue,
  withDelay,
  withSequence,
  withTiming,
} from 'react-native-reanimated';
import { useGoodsDetail } from '../../../../queries/useGoodsDetail';
import { useInstanceId, useScreenshot } from 'shared/src/hooks';
import { bridge, isAndroid, isNotNil, localizeNumber } from 'shared/src/utils';
import { scheduleOnRN } from 'react-native-worklets';
import { useLogClickShareGoods } from './hooks/useLogClickShareGoods';

const CLOSED_BUTTON_SIZE = isAndroid ? 46 : 41;
const OPENED_BUTTON_SIZE = isAndroid ? 92 : 80;

export const ShareRewardButton: React.FC = () => {
  const animValue = useSharedValue<number>(41);
  const [reward, setReward] = useState(0);
  const [runOnce, setRunOnce] = useState<boolean>(false);
  // const { show: showShareGoodsBottomSheet } = useShareGoodsBottomSheet();
  const logClickShareGoods = useLogClickShareGoods();

  const instanceId = useInstanceId();
  const { data: goodsDetail } = useGoodsDetail();

  useScreenshot({
    instanceId,
    onCapture: () => {
      if (isNotNil(goodsDetail)) {
        bridge.openGoodsShare({
          is_by_screenshot: true,
          goods_sno: goodsDetail.goods.sno,
          affiliate_reward: goodsDetail.affiliate,
        });
      }
    },
  });

  useEffect(() => {
    if (isNotNil(goodsDetail)) {
      setRunOnce(true);
      setTimeout(() => {
        animValue.value = withSequence(
          withTiming(
            CLOSED_BUTTON_SIZE,
            {
              duration: 200,
              easing: Easing.inOut(Easing.quad),
            },
            () => {
              scheduleOnRN(setReward, goodsDetail.affiliate.expected_reward);
            },
          ),
          withTiming(OPENED_BUTTON_SIZE, {
            duration: 200,
            easing: Easing.inOut(Easing.circle),
          }),
          withDelay(
            1200,
            withTiming(
              OPENED_BUTTON_SIZE,
              {
                duration: 200,
              },
              () => {
                scheduleOnRN(setReward, 0);
              },
            ),
          ),
          withTiming(CLOSED_BUTTON_SIZE, {
            duration: 200,
            easing: Easing.inOut(Easing.quad),
          }),
        );
      }, 10);
    }
  }, [goodsDetail, animValue, runOnce]);

  const styles = useAnimatedStyle(() => {
    return {
      width: animValue.value,
      height: 16,
    };
  });

  return (
    <Flex.Row
      padding={{ horizontal: 10, vertical: 6 }}
      gap={4}
      backgroundColor={'bg_secondary'}
      borderRadius={'medium'}
      onPress={() => {
        logClickShareGoods();
        if (isNotNil(goodsDetail)) {
          bridge.openGoodsShare({
            is_by_screenshot: false,
            goods_sno: goodsDetail.goods.sno,
            affiliate_reward: goodsDetail.affiliate,
          });
        }
      }}
      testID={'공유버튼'}
    >
      <IconShare size={16} fill={Colors.content_secondary} />
      <Animated.View style={styles}>
        {reward > 0 ? (
          <Typography type={'subtitle4'}>
            최대{' '}
            <Typography type={'subtitle4'} color={'content_blue_primary'}>
              {localizeNumber(reward)}원
            </Typography>{' '}
            받기
          </Typography>
        ) : (
          <Typography type={'subtitle4'}>공유하기</Typography>
        )}
      </Animated.View>
    </Flex.Row>
  );
};
